import { createReduxStore, register } from '@wordpress/data';
import { useSelect } from '@wordpress/data';

import * as actions from './actions';
import * as selectors from './selectors';
import reducer from './reducer'
import axios from 'axios';

export const store = createReduxStore('custom-store', {
    reducer,
    selectors,
    actions,
    controls: {},
    resolvers: {
        async getUserLoggedIn() {
            const response = await axios.get(`/wp-admin/admin-ajax.php?action=get_data_user`)
                .then(res => res.data.data)

            return { type: 'SET_USER_LOGGED_IN', payload: response }
        }
    },
});

register(store);